import 'url-polyfill';
import $ from 'jquery';
import 'webpack-jquery-ui/datepicker';
import 'selectric';

$.datepicker.regional[ 'sv' ] = {
  closeText: 'Stäng',
  prevText: '< Föregående',
  nextText: 'Nästa >',
  currentText: 'Nu',
  monthNames: [
    'Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni',
    'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
  monthNamesShort: [
    'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun',
    'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
  dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
  dayNames: [
    'Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag',
    'Fredag', 'Lördag'],
  dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
  weekHeader: 'Не',
  dateFormat: 'yy-mm-dd',
  firstDay: 1,
  isRTL: false,
  showMonthAfterYear: false,
  yearSuffix: '',
};
$.datepicker.setDefaults($.datepicker.regional[ 'sv' ]);

class EventsArchive {
  constructor($el) {
    this.$el = $el;
    this.datepicker = this.$el.find('.js-datepicker');
    this.location = this.$el.find('.js-location');
    this.locationInitValue = null;
    this.init();
  }

  init() {
    this.initDatepicker();
    this.initLocationPicker();
    this.initValue();
    this.events();
  }

  initLocationPicker() {
    this.location.selectric({
      disableOnMobile: false,
      nativeOnMobile: false,
      onInit: (element) => {
        this.locationInitValue = $(element).val();
      },
      onChange: (element, selectric) => {
        return this.onLocationChange(element, selectric);
      },
      onOpen: () => {
        const getWindowWidth = $(window).width();
        console.log(getWindowWidth);

        this.location.parents('.selectric-wrapper')
          .find('.selectric-items').css({
            'width': getWindowWidth + 'px',
          });

        this.location.parents('.event-filter__item')
          .addClass('event-filter__item--focus');
      },
      onClose: () => {
        this.location.parents('.event-filter__item')
          .removeClass('event-filter__item--focus');
      },
    });
  }

  initDatepicker() {
    
    let choosenDate = this.datepicker.val(),
      datepickerWidth = this.datepicker.outerWidth();

    let datepickerParams = {
      showOtherMonths: true,
      selectOtherMonths: true,
      autoSize: true,
      onSelect: (value, inst) => {
        this.onDatepickerChange(value, inst);
        if (value !== choosenDate) {
          this.datepicker.parent().addClass('active');
        }
        else {
          this.datepicker.parent().removeClass('active');
        }
      },
      beforeShow: (input, inst) => {
        if ($(window).width() >= 768) {
          setTimeout(function() {
            $('#ui-datepicker-div').css({
              'left': clPos + 'px',
            });
          }, 1);
        }
        else {
          setTimeout(function() {
            $('#ui-datepicker-div').css({
              'left': 0,
            });
          }, 1);
        }
        this.datepicker.parents('.event-filter__item')
          .addClass('event-filter__item--focus');
      },
      onClose: () => {
        this.datepicker.parents('.event-filter__item')
          .removeClass('event-filter__item--focus');
      },

    };
    this.datepicker.datepicker(datepickerParams);
    let positionLeft = this.datepicker.offset().left,
      positionWidth = $('#ui-datepicker-div').outerWidth(),
      clPos = (positionLeft - (positionWidth - datepickerWidth));

      
  }

  initValue() {
    let url = new URL(location.href);

    if (url.searchParams.has('date')) {
      this.datepicker.datepicker('setDate', url.searchParams.get('date'));
    }

    if (url.searchParams.has('place')) {
      let selectedPlace = url.searchParams.get('place');
      this.location
        .val(selectedPlace)
        .change()
        .selectric('refresh');
    }
  }

  onDatepickerChange(value, instance) {
    let url = location.href;
    url = new URL(url);
    if (value.length) {
      url.searchParams.set('date', value);
    }
    else {
      url.searchParams.delete('date');
    }

    location.href = url.href;

    $.fn.textWidth = function(text, font) {
    
      if (!$.fn.textWidth.fakeEl) {
        $.fn.textWidth.fakeEl = $('<span>').hide().appendTo(document.body);
      }
      
      $.fn.textWidth.fakeEl.text(text || this.val() || 
      this.text() || 
      this.attr('placeholder'))
        .css('font', font || this.css('font'));
        
      return $.fn.textWidth.fakeEl.width();
    };
  
    this.datepicker.on('input', function() {
      var inputWidth = $(this).textWidth();
      $(this).css({
        width: inputWidth + 35 + 'px',
      });
    }).trigger('input');
  
  
    function inputWidth(elem, minW, maxW) {
      elem = $(this);
      console.log(elem);
    }
  


  }

  onLocationChange(element, selectric) {
    let url = new URL(location.href);
    let value = $(element).val();
    if (value.length) {
      url.searchParams.set('place', value);
    }
    else {
      url.searchParams.delete('place');
    }
    location.href = url.href;

    if (value !== this.locationInitValue) {
      $(element)
        .parents('.selectric-wrapper')
        .parent()
        .addClass('active');
    }
    else {
      $(element)
        .parents('.selectric-wrapper')
        .parent()
        .removeClass('active');
    }
  }

  events() {
    this.datepicker
      .change(function() {

      });
  }

}

const initEventPage = function() {
  const event = $('section.event');
  if (event.length !== 0) {
    new EventsArchive(event);
  }
};


export default initEventPage;
